import { render, staticRenderFns } from "@/style-guide/partials/counter/counter.pug?vue&type=template&id=9c6c0480&scoped=true&lang=pug&external"
import script from "./counter.vue?vue&type=script&lang=ts"
export * from "./counter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6c0480",
  null
  
)

export default component.exports